import { proxy } from 'valtio';

import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

import { type AddFlagProps, type Flag } from '../index';

/**
 * A flags manager implementation to manage hiding and showing flags.
 */
export abstract class FlagsManager {
  constructor(
    /**
     * A proxy object containing an array of flags.
     *
     * @readonly
     */
    public readonly flags: { data: Flag[] } = proxy({ data: [] })
  ) {}

  /**
   * @deprecated Use showFlag instead.
   * Adds a new flag with the specified properties.
   */
  abstract addFlag(props: AddFlagProps): void;

  /**
   * @deprecated Use hideAllFlags instead.
   * Clears all flags.
   */
  abstract clearFlags(): void;

  /**
   * @deprecated Use hideFlag instead.
   * Handles the dismissal of a flag.
   */
  abstract handleFlagDismiss(flagId: number | string): void;

  // Migration: methods for the future manager implementation
  /**
   * Shows a flag with the specified properties.
   */
  abstract showFlag(props: ContentTypesFlagProps): void;

  /**
   * Hides a flag with the specified ID.
   */
  abstract hideFlag(flagId: string): void;

  /**
   * Hides all flags.
   */
  abstract hideAllFlags(): void;
}
